import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth26: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M3.7,52.5l1-19.3,10.2-9.5,11.9-7.1,13.3-5.7,13.3-3.8,11.7-1.2,13.8,1.2,11.9,1.4,12.6,1.4,10.2,2.4,9.5,4.3,7.4,4.3,15.7-5.5,13.3-2.6h24.7l13.8,4.8,13.8,11.2,9,14,3.8,10.9.5,11.9-.2,17.6-1.7,16.4-2.4,11.9-4.3,15s-50.6,45-186.7,8.8l-9.3-22.5-10.5-35.7-6.4-24.6Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M134.4,67.1a17,17 0 1,1 -34,0a17,17 0 1,1 34,0',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M64.7,7.4v73.2s1.9,21.3-15.1,21.3h-31L4.6,55.8v-19.1l4.8-7.8,6.4-4.9,8.3-5.3,9.2-4.1,9.4-3.5,9.5-2.5,12.6-1.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M161.9,14.9l18.7-.3,10.3,2.1,8.3,3.8,8,6.2,7,7.3,5.4,9.7,3.3,9.9,1.4,5.9v21.6l-1.3,10-1.9,11.3h-43s-16.6,3-16.6-13.8l.3-73.7Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.9,135.3s123.2,36.5,186.7-8.8l-7.2,15.2s-54.3,46-176,3l-3.4-9.4Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M130.5,20.9l-16.9-8.6-22.8-3.8-25.7-2.6-11.7,1.2-13.3,3.8-13.3,5.7-11.9,7.1-10.2,9.5-1.2,9.2v9.2l2.2,11.9,7.8,23,7.2,26.2,9.3,22.5c43.4,12.7,86.2,14,86.2,14,0,0-31.3-95.1,14.4-128.4Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M216.5,126.5l4.3-15,2.4-11.9,1.7-16.4.2-17.6-.5-11.9-3.8-10.9-9-14-13.8-11.2-13.8-4.8h-24.7l-13.3,2.6-15.7,5.5s-45.2,21.5-14.4,128.4c0,0,66.8,3.9,100.5-22.8Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8.6 69.9 37.6 46.7 42.8 83.9 63.4 44.3 81.3 85.2 99.9 43.8 119.5 82.4 138.1 42.2 156.8 82.9 174.5 41.4 190.6 81.8 201.7 44.9 223.5 71.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'121.8 101.3 106.5 110.5 124.5 120.7 109 130 125.7 139.5 111 148.4 125.9 156.8 111.7 165.5 128.9 175.2 114.8 183.5 128.6 191.2 114.6 199.6 129.7 208 114.8 217 129 224.8 114.1 233.7 127.4 241.3 112.9 249.9 128.9 259 112 269.1 127.4 278 110.7 287.9 126.7 296.9 110.2 306.7 128.3 317 113.2 326.1 130.1 335.7 112.1 346.4 128.1 355.5 111.8 365.2 128.8 374.7 111.3 387.9 128.3 394.5 111 408.3 129.6 413.8 115.7 437.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'180 280.3 171.5 263.7 160.1 280.5 148.1 265 136.8 280.5 122.5 263.4 108.2 280.5 95.4 263.7 79.7 283.3 66.7 265.4 53.9 282.9',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.3,41.4l4.3-9.7,2.6-3.2,2.4-2.8,2.2-2.4,4.9-4.3,5.5-3,4.7-2.8,4.9-2.4,5.5-2,5.5-1.2,5.1-1s1.2-.2,2.6-.2,7.7.4,7.7.4l3.5.2,5.9,1.8,3.2,1.4,5.9,1.6,4.5,1.6,6.7,2,4.5,1.2,3.2.8,12.8.2h5.5l4.7.6,6.9,1.8,6.1,2.6,5.5,3,8.5,4.7,6.3,5.5,5.9,5.3,4.1,4.3,1.6,2.6,1.8,4.5,2,3.5,1.2,9.5s.8,4.3.8,4.9.8,7.3.8,7.3l11,36.3.2,6.5.2,7.7-.6,8.9-.6,7.1-1.4,4.9-2.2,6.5-2.6,4.9-4.1,7.5-3.9,5.1-6.7,4.5-7.7,5.5-7.1,2.6-3.5,2.4-7.5,3.2-4.9,1-8.1,1.6-8.5,2-13.8.8-6.9,1-4.3.2-5.3-.2-9.5.4h-4.3l-5.1-1.2-10.1-2.8-6.9-2.6-4.9-3.5-4.1-3.9-4.1-4.1-3-3.2-3.7-5.3-6.1-11.8-6.1-14-6.1-12.4-5.1-14.6-2.4-11.8-3.7-29.4.2-18.3,1.2-9.3,2.2-8.5h.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.4,155.9l-3-8.9-6-10.6-4.9-16-5.4-19.5-2.2-17.3-.3-17.1,1.1-12.7,3.3-12.5,35.9,32.8s29,18.8,11.3,45.2l-29.9,36.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M188.1,49.3l4.1,7.4,1.3,12.7,1.3,7.4,7.6,19.6,3.5,12.9.7,8.7.2,18.3-3.9,19-39.1-30.9-3-2.7s-20.3-17.1-3.1-34.8l8.7-10.5,21.6-27.1Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.5,14.6l-26-8.5-15.3-.2-16.8,6.1-11.6,7.2-8.9,7.4-5.7,8.1-2.1,6.7,35.9,32.8s33.3,14.1,41.2,2.4,10.8-23.8,9.3-62Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.5,14.6l8.5,2.8,14.6-.7,11.6,1.7,12.2,4.1,10.5,5.7,8.7,6.3,6.5,6.1,3.9,8.5-21.6,27.1s-23.2,8.5-29.5,1.7c-20.7-22.4-34.8-1.5-34.8-1.5,0,0,11.2-26.4,9.3-62Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M202.9,155.3l-5.7,10.1-10.5,11.8-14,9-18,7.2-14.9,2.9-12.1,1.1s-2.5-32.7,14.2-51.7c6.6-7.6,9.6-13.4,10.8-17.6,1.7-6.2-.4-9-.4-9l11.6,5.3,39.1,30.9Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.6,197.5h-36l-17.3-3.7-13.1-9.7-8.9-10.1-9.9-18.1,29.9-36.6s8.9-5.8,19.1-5.8,15.3,10.9,27.1,10.9,11.6-9,22.2-9.1,11.6,3.9,11.4,3.8c8.1,10.1-10.3,26.6-10.3,26.6,0,0-14.9,15.4-14.2,51.7Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61,74.1s33.1,13.7,41.2,2.4c11.6-16.1,27.3-7.2,34.8,1.5s26.5-1.8,29.5-1.7-30.2,22.9-5.6,45.3l3,2.7s-19-9.1-23-9.1-9,9.1-22.2,9.1-18.4-10.9-27.1-10.9-19.1,5.8-19.1,5.8c-10.7,8,24.6-18.2-11.3-45.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'204.1 111 186.6 82.4 177.3 120.8 165.2 73.8 149.1 122.1 134.4 73.8 117.9 121.5 102.5 73.8 86.1 124.5 72.5 76.3 54.8 124.5 49.3 84.2 26.8 110.4',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M218.1,370.9l4.6,15.1,1.5,12.8,2.1,15.9,1,9.7-.8,9.2-1.8,8.2-3.1,8.7-5.6,7.2-1.8,7.9-3.6,10.3-5.6,9.2-6.9,5.9-9.2,4.6-14.1,3.3-7.7.5-14.6.3-26.1-4.4h-14.6l-22,6.9-31.3.3-18.5-4.1-18.7-6.2-11.3-10-4.1-11-1.3-11.5,1-11.3,4.4-19,17.2-40.7s77.8-39.5,190.9-17.9Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.1,388.8s77.3-39.5,190.9-17.9l-2.9-9.5s-102-29.2-182.7,15.4l-5.3,12Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M138,425.8a16,16 0 1,1 -32,0a16,16 0 1,1 32,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.1,411.4h46.1s11.3,1.8,11.3,13.8v77.1l-16.4.3-23.8-5.1-16.7-7.2-9-8.5-4.6-11.3-.8-19.2,4.6-19.2,9.2-20.8Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M225.4,410.9h-54.8s-11.8,3.1-11.8,13.1.8,75.9.8,75.9l27.9-4.1,11-4.9,9.2-9.2,5.6-11.5,3.3-12.8,6.9-9.7,3.8-13.8v-15.9l-2.1-6.9Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M123.1,494.9l15.1,2.1,17.4,2.6h15.6l16.9-3.8,13.8-6.9,7.7-10,4.6-10.5,1.8-9.5,7.7-12,3.3-15.4v-16.9l-2.8-22.6-6.3-21s-40.8-8-72.7-6.4c0,0,9.5,32.2-3.3,51.5s-19,78.9-19,78.9Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.1,388.8l-17.2,40.7-4.4,19-1,11.3,1.3,11.5,4.1,11,11.3,10,18.7,6.2,18.5,4.1,31.3-.3,22-6.9,11.4-.5s5.8-58.3,19-78.9c12.6-19.7,3.3-51.5,3.3-51.5,0,0-63.9-1.1-118.3,24.3Z"',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'222.5 443.4 201.8 412.9 190.8 455.8 176.3 403.7 157.2 457.2 139.5 403.7 119.6 456.6 101.3 403.7 81.4 460 65.4 406.4 44 460 37.4 415.1 9 445.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'187.5 81.8 193.6 100.6 178.2 106.5 189.2 121.2 172.7 126.3 185.7 139.3 171.4 147.2 184 157.1 166.5 162.4 181.3 175.6 163.8 182.5 178.9 193.1 162.8 199.6 177.5 209.5 160.4 214.8 175 225.6 159.5 232.4 172.1 241.6 159.2 247.4 172 256.9 158.4 262.9 171.2 272.4 156.6 278.8 168.8 287.8 155.4 293.7 167.6 302.6 150.9 310 163.3 319.2 148.8 325.6 161.5 335.1 145.4 342.3 158.8 352.3 141.3 360 154.6 369.9',
				'74.9 373 89.1 359.1 72.8 352.3 86 341.2 69.4 334.9 83.5 324.3 69.4 317.1 82.2 308.6 66 300.3 78.6 292.1 65.6 285.5 78.2 277.2 64 270 77.3 261.2 64 254.5 77.3 245.7 64.8 239.2 77.8 230.7 62.7 223 77.9 213 63.4 205.4 78.4 195.6 63.3 187.9 78.1 178.2 61.1 169.4 74.6 160.4 61.8 151.4 76.3 143.7 65.1 134.1 80 125.9 68.1 114 85.7 109.5 78.8 93.9 93.6 93.1 89.2 66.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'192.4 232.1 181.9 214.4 163.3 234.1 151.3 215 134.5 233.7 117.9 214.2 105.2 234.7 88.7 214.4 69.5 235.2 53.3 216.2 36.7 234.9',
			],
		},
	},
};
